var _excluded = ["autoSelect", "index", "initialValue", "onBackspace", "changeFocus", "onSubmit", "onChange", "onPaste", "onBlur", "onFocus"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { useInputBase } from './useInputBase';
import { Column, DigitBase, InputBase as StyledInputBase } from '../InputPin.style';
export var InputBase = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    autoSelect,
    index,
    initialValue,
    onBackspace,
    changeFocus,
    onSubmit,
    onChange: onChangeParent,
    onPaste: onPastParent,
    onBlur: onBlurParent,
    onFocus: onFocusParent
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    input,
    value,
    onKeyDown,
    onPaste,
    onChange,
    onFocus,
    onBlur,
    isFocused,
    focus,
    update
  } = useInputBase({
    autoSelect,
    changeFocus,
    index,
    initialValue,
    onBackspace,
    onSubmit,
    onChange: onChangeParent,
    onPaste: onPastParent,
    onBlur: onBlurParent,
    onFocus: onFocusParent
  });
  React.useImperativeHandle(ref, () => ({
    update,
    focus
  }));
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(StyledInputBase, _extends({}, props, {
    "data-testid": "pin-".concat(index),
    ref: input,
    onDragStart: e => {
      e.preventDefault();
    },
    value: value,
    onKeyDown: onKeyDown,
    onPaste: onPaste,
    onChange: onChange,
    maxLength: 1,
    inputMode: "numeric",
    onFocus: onFocus,
    onBlur: onBlur,
    autoComplete: "off"
  })), /*#__PURE__*/React.createElement(DigitBase, {
    active: isFocused
  }));
});
//# sourceMappingURL=InputBase.js.map